<script lang="ts" setup>
import { useService } from '@kaokei/use-vue-service';
import { LoginService } from '@core/services/login.service';
import LoginPanel from './LoginPanel.vue';

const loginService = useService(LoginService);
</script>

<template>
  <a-modal
    v-model:open="loginService.visible"
    centered
    width="800px"
    :footer="null"
  >
    <LoginPanel />
  </a-modal>
</template>
